<template>
  <c-box id="app">
    <router-view></router-view>
  </c-box>
</template>

<script lang="ts">
import Vue from "vue";
import { CBox } from "@chakra-ui/vue";

export default Vue.extend({
  name: "App",
  inject: ["$chakraColorMode", "$toggleColorMode"],
  components: {
    CBox,
  },
  computed: {
    colorMode() {
      return this.$chakraColorMode();
    },
  },
});
</script>

<style>
* {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen,
    Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

/* Theme CSS Variables */
:root,
[data-theme="light"] {
  --bg-primary: #f8f9fc;
  --bg-secondary: #eef1f8;
  --bg-tertiary: #e4e9f2;
  --panel-bg: #ffffff;
  --card-bg: #ffffff;
  --card-hover: #f0f4ff;
  --surface-bg: rgba(255,255,255,0.95);
  --surface-border: rgba(0,0,0,0.06);
  --border-color: rgba(0,0,0,0.08);
  --text-primary: #1a1a2e;
  --text-secondary: #4a5568;
  --text-tertiary: #a0aec0;
  --accent: #4f7cff;
  --accent-subtle: rgba(79, 124, 255, 0.08);
  --accent-glow: rgba(79, 124, 255, 0.15);
  --success: #38b2ac;
  --success-subtle: rgba(56, 178, 172, 0.08);
  --danger: #e53e3e;
  --danger-subtle: rgba(229, 62, 62, 0.06);
  --header-bg: rgba(255,255,255,0.85);
  --footer-bg: rgba(255,255,255,0.6);
  --input-bg: #f7f8fc;
  --input-border: rgba(0,0,0,0.1);
  --shadow-sm: 0 1px 3px rgba(0,0,0,0.04);
  --shadow-md: 0 4px 12px rgba(0,0,0,0.06);
  --shadow-lg: 0 8px 30px rgba(0,0,0,0.08);
  --shadow-card: 0 2px 8px rgba(0,0,0,0.06), 0 0 0 1px rgba(0,0,0,0.04);
  --table-gradient: linear-gradient(145deg, #e8f0fe, #d4e4ff);
  --table-border: rgba(79, 124, 255, 0.15);
  --table-glow: rgba(79, 124, 255, 0.06);
}

[data-theme="dark"] {
  --bg-primary: #0a0a0f;
  --bg-secondary: #111118;
  --bg-tertiary: #1a1a24;
  --panel-bg: #141420;
  --card-bg: #1c1c2a;
  --card-hover: #252538;
  --surface-bg: rgba(255,255,255,0.02);
  --surface-border: rgba(255,255,255,0.06);
  --border-color: rgba(255,255,255,0.08);
  --text-primary: #f0f0f5;
  --text-secondary: rgba(255,255,255,0.65);
  --text-tertiary: rgba(255,255,255,0.35);
  --accent: #6c8cff;
  --accent-subtle: rgba(108, 140, 255, 0.12);
  --accent-glow: rgba(108, 140, 255, 0.2);
  --success: #4fd1c5;
  --success-subtle: rgba(79, 209, 197, 0.12);
  --danger: #fc8181;
  --danger-subtle: rgba(252, 129, 129, 0.1);
  --header-bg: rgba(10, 10, 15, 0.8);
  --footer-bg: rgba(0,0,0,0.5);
  --input-bg: rgba(255,255,255,0.04);
  --input-border: rgba(255,255,255,0.1);
  --shadow-sm: 0 1px 3px rgba(0,0,0,0.3);
  --shadow-md: 0 4px 12px rgba(0,0,0,0.4);
  --shadow-lg: 0 8px 30px rgba(0,0,0,0.5);
  --shadow-card: 0 2px 8px rgba(0,0,0,0.4), 0 0 0 1px rgba(255,255,255,0.06);
  --table-gradient: linear-gradient(145deg, #1a1a2e, #141428);
  --table-border: rgba(108, 140, 255, 0.15);
  --table-glow: rgba(108, 140, 255, 0.05);
}

html, body {
  overflow-x: hidden;
  width: 100%;
}

body {
  background: var(--bg-primary);
  min-height: 100vh;
  color: var(--text-primary);
  transition: background 0.35s ease, color 0.35s ease;
}

#app {
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
}
</style>
